import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDatasetCounts = defineStore('datasetCounts', () => {
  const count = ref(0);

  const setDatasetCounts = (value) => {
    if (typeof value === 'number') {
      count.value = value.toFixed();
    } else {
      count.value = value;
    }
  };

  return {
    count,
    setDatasetCounts,
  };
});
